export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#1C1917] px-4 pb-28 pt-14 text-center md:pb-14"
    >
      <p className="mx-auto max-w-md font-display text-lg italic leading-relaxed text-[#C5A059]">
        « Un grand arbre est tombé, mais ses racines continuent de nourrir nos
        mœurs. »
      </p>
      <div className="mx-auto mt-8 h-px w-16 bg-[#C5A059]/50" />
      <p className="mt-8 text-sm font-medium text-stone-200">
        Famille TANDJIEKPON &amp; Collectivités alliées — En mémoire éternelle
      </p>
      <p className="mt-2 text-xs text-stone-500">
        Banigbé-Gare, Commune d'Ifangni, République du Bénin • 1938 – 2026
      </p>
      <p className="mt-6 font-display text-xs tracking-[0.3em] text-stone-600">
        MÉMORIUM
      </p>
      <a
        data-testid="footer-admin-link"
        href="/admin"
        className="mt-3 inline-block text-[11px] text-stone-600 underline-offset-4 transition-colors hover:text-[#C5A059] hover:underline"
      >
        Espace famille
      </a>
    </footer>
  );
}
